import React from "react";
import { LegalPage, LegalSection } from "@/components/Legal";

export default function Terms() {
  return (
    <LegalPage title="Terms and Conditions" updated="July 2026" testid="terms-page">
      <LegalSection title="1. The platform">
        <p>
          Boat RV Moving (boatrvmoving.com) is an online marketplace that connects people who need boats and
          RVs moved ("shippers") with independent transport drivers ("drivers").{" "}
          <strong className="text-zinc-200">
            Boat RV Moving is not a motor carrier, broker, or freight forwarder
          </strong>{" "}
          and does not provide transportation services. Any transport agreement is made directly between
          the shipper and the driver.
        </p>
      </LegalSection>

      <LegalSection title="2. Accounts and verification">
        <p>
          You must provide accurate information when registering. Drivers are verified against the FMCSA
          SAFER database and must submit a valid driver's license and proof of insurance. We may approve,
          reject, suspend, or remove accounts at our discretion to keep the marketplace safe. One account
          per person; keep your credentials confidential.
        </p>
      </LegalSection>

      <LegalSection title="3. Shipper responsibilities">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Post accurate listings: correct dimensions, weight, condition, and pickup/delivery details.</li>
          <li>Ensure the item is legally transportable, ready at the agreed time, and free of prohibited goods.</li>
          <li>Pay the agreed price promptly and fairly through the platform's payment flow.</li>
          <li>Inspect the item at delivery and report issues within 48 hours.</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Driver responsibilities">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Hold and maintain a valid USDOT registration, driver's license, and adequate insurance at all times.</li>
          <li>Comply with all FMCSA, DOT, and state regulations, including hours-of-service and load securement rules.</li>
          <li>Transport items with reasonable care, meet agreed schedules, and communicate delays promptly.</li>
          <li>Document condition with photos at pickup and delivery when requested.</li>
        </ul>
      </LegalSection>

      <LegalSection title="5. Bids, payments, and fees">
        <p>
          A bid accepted by a shipper forms a direct agreement between shipper and driver. Platform
          subscriptions and fees (if any) are shown before you pay and are billed through Stripe. Completed
          hauls and ratings are recorded to build marketplace trust and may not be removed except for
          policy violations.
        </p>
      </LegalSection>

      <LegalSection title="6. SMS program">
        <p>
          By providing your phone number you agree to receive SMS messages from Boat RV Moving (service
          updates and notifications). Message frequency varies; message and data rates may apply. Reply{" "}
          <strong className="text-zinc-200">STOP</strong> to opt out or{" "}
          <strong className="text-zinc-200">HELP</strong> for help. See our{" "}
          <a href="/privacy-policy" className="text-[#FF3B30] hover:text-white underline underline-offset-2">Privacy Policy</a>{" "}
          — mobile opt-in data is never shared with third parties.
        </p>
      </LegalSection>

      <LegalSection title="7. Acceptable use">
        <p>
          No scraping, fraud, harassment, circumvention of fees, or unlawful cargo. We moderate messages
          and may remove content or accounts that violate these rules.
        </p>
      </LegalSection>

      <LegalSection title="8. Disclaimers and liability">
        <p>
          The platform is provided "as is." We do not perform the transport and are not a party to the
          transport agreement, so we are not responsible for loss, damage, delays, injury, or disputes
          arising from a haul — those are between shipper and driver, and typically covered by the driver's
          cargo insurance. To the maximum extent permitted by law, Boat RV Moving's total liability for any
          claim related to the platform is limited to the fees you paid us in the 12 months before the
          claim, or $100 if none. Nothing here limits liability that cannot be limited by law.
        </p>
      </LegalSection>

      <LegalSection title="9. Termination and changes">
        <p>
          You may close your account at any time by contacting us. We may suspend accounts for safety or
          policy violations. We may update these terms; continued use after an update means you accept it.
          Material changes are announced in the app or by email.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
